/**
 * @namespace Enum
 * @class
 */
export class Enum {
    /**
     * Dado um id busca e retorna um item do enum
     * @param {String | number} id - id do item do enum
     * @returns {EnumItem} Item do enum
     * @link EnumItem
     */
    getById(id) {
        return this.getBy('id', id)
    }

    /**
     * Dada a chave do enum, retorna o enum
     * @param {String} key - chave
     * @returns {EnumItem} Item do enum
     */
    getByKey(key) {
        return this.getBy('key', key)
    }

    /**
     * Dado um id busca e retorna um item do enum
     * @param {String} attrName - atributo a ser buscado no enum
     * @param {Any} serachValue - valor do atributo a ser buscado no enum
     * @returns {EnumItem} Item do enum
     */
    getBy(attrName, searchValue) {
        for (let item in this) {
            if (this[item][attrName] === searchValue) {
                return this[item]
            }
        }
    }
}